import { render } from "./InstructorAddModal.vue?vue&type=template&id=5ace88f4&scoped=true"
import script from "./InstructorAddModal.vue?vue&type=script&lang=js"
export * from "./InstructorAddModal.vue?vue&type=script&lang=js"

import "./InstructorAddModal.vue?vue&type=style&index=0&id=5ace88f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ace88f4"]])

export default __exports__